import { z } from 'zod'
import { Model } from '../../_kernel/architecture'

export type BannerTypes = (typeof ALLOWED_BANNER_TYPE)[number]

export const ALLOWED_BANNER_TYPE = [
  'billboard-banner',
  'announcement-banner',
  'hero-banner',
  'block-banner',
] as const

export const BannerTypeValidation = z.object({
  value: z.enum(ALLOWED_BANNER_TYPE, {
    required_error: 'value is required',
  }),
})

export class BannerType extends Model {
  static create({ value }: z.infer<typeof BannerTypeValidation>) {
    BannerTypeValidation.parse({ value })
    return new BannerType(value)
  }

  constructor(private readonly _value: BannerTypes) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
